import { Component, OnInit, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { Observable, of } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';

import { MenuSubMenu } from '../../../app/shared/menu/menu-sub-menu.model';
import { MenuService } from '../../shared/header/menu/menu.service';
import { BreakpointObserver } from '@angular/cdk/layout';
import { UtilService } from '@app/shared/utils';

@Component({
  selector: 'app-search-result-container',
  templateUrl: './search-result-container.component.html',
  styleUrls: ['./search-result-container.component.css']
})
export class SearchResultContainerComponent implements OnInit {
  searchResults: Array<MenuSubMenu>;
  searchResults$: Observable<any>;
  displayedColumns: string[] = ['idUser'];
  dataSource = new MatTableDataSource<any>(this.dataSource);
  pageSizeOptions: number[] = [10, 20, 50];
  searchTerm: string;
  @Input() initialTabindex: number;
  @Output() searchTermChange = new EventEmitter<object>();
  
  /***
   * CSCSATIVA-5524 - Desenvolvimento - Ajuste Navegação Teclado tela resultado Pesquisa "Caixa Pesquisa"
   * Conforme alinhado com Patricia Moreira e validado com Willian Pimentel, paginação será retirada 
   * para facilitar navegação por teclado a fim de atender o criterio acessibilidade.
   * */
  //@ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private route: ActivatedRoute, private menuService: MenuService, private breakpointObserver: BreakpointObserver, private util: UtilService) { }

  ngOnInit() {      
    /*this.paginator.page.subscribe((event)=> {
      console.log(event);
    });    
    this.dataSource.paginator = this.paginator;*/ 

    this.dataSource.sort = this.sort;
    this.route.paramMap.pipe(
      switchMap((params: ParamMap) => {
        this.searchTerm = params.get('searchTerm');
        return of(this.searchTerm);
      })
    ).subscribe((query: string) => {
      this.getSearchResults(query);
    })
    //this.adjustTabIndexPaginator();
  }

  getSearchResults(query?: string): void {
    try {

      this.searchResults = this.menuService.filterMenu(query);
      this.searchTermChange.emit({ searchTerm: query, itemCount: this.searchResults.length });
      this.dataSource = new MatTableDataSource<any>(this.searchResults);
      
      /*this.dataSource.paginator = this.paginator;*/

      setTimeout(()=>{
        this.util.requestFocusOnFirstOcurrence("resultSearchLink");
        //this.adjustTabIndexPaginator();
      })
    }
    catch
    { }
  }

  /*adjustTabIndexPaginator(){
    let buttonPaginatorPrevious = this.util.getFirstElememtByClassName("mat-paginator-navigation-previous");
    if(buttonPaginatorPrevious){
      buttonPaginatorPrevious.tabIndex=this.initialTabindex;
    }

    let buttonPaginatorNext = this.util.getFirstElememtByClassName("mat-paginator-navigation-next");
    if(buttonPaginatorNext){
      buttonPaginatorNext.tabIndex=this.initialTabindex;
    }    

    let pageSizePaginator = this.util.getFirstElememtByClassName("mat-select");
    if(pageSizePaginator){
      pageSizePaginator.tabIndex=this.initialTabindex;
    }    
  }*/

  get paginatorLength(): number {
    return this.dataSource.data.length;
  }
}
